import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';

export class IdAttribute extends AbstractBlock {
  constructor(name: string, title: string) {
    super(name, title);
  }
  /**
   * ブロックの外観定義
   * @param {ブロック} block
   */
  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setAttributeShape(block);

    ShapeSettings.setIdField(block);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const id = CodeSetting.getFieldValue(block, 'id');
    // let str =  " id ='"  + id + "' " + attribute ;
    const str = CodeSetting.buildAttribute([['id', id]], attribute);
    return [str];
  }
}
